import {HttpService} from "../http/HttpService";
import {BonusOffer, ListMinimalUserMessageProjectionResponse, UserMessage, UserMessageMinimalProjection} from "../http/protocol";

export interface MessagePaginationParams {
    limit: number;
    offset: number;
    ascending: boolean;
}

export class MessageService {
    constructor(private http: HttpService) {
    }

    getMessages(params: MessagePaginationParams = { limit: 20, offset: 0, ascending: false }): Promise<ListMinimalUserMessageProjectionResponse> {
       return this.http.post("/messages/list", params);
    }
    getMessageAndMarkAsRead(id : number) : Promise<UserMessage>{
        return this.http.get("/messages/"+id);
    }
    markRead(id : number) : Promise<{}>{
        return this.http.get("/messages/mark/read/"+id);
    }
    markAllAsRead() : Promise<{}>{
        return this.http.get("/messages/mark/all-read");
    }
}